<!-- Dialog: ACCEPT INTO-->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [modal]="true"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header> {{ data.dialogData.title_text }} </p-header>

  <div fxLayoutWrap>
    <div class="order__dialog__accept-into__message_container">
      <div class="order__dialog__accept-into__message_text">{{ data.dialogData.message_text }}</div>

      <bfx-autoComplete
        #acceptInto_autoComplete
        [(ngModel)]="data.dialogData.autocomplete_traderGroup"
        [suggestions]="data.dialogData.autocomplete_traderGroupsFiltered"
        ng-disabled="data.dialogData.autocomplete_traderGroupsDefaultOnly"
        field="label"
        size="sm"
        class="order__dialog__accept-into__message_dropdown"
        (completeMethod)="helperAcceptInto_searchTraderGroup($event)"
        [dropdown]="true"
        autoHighlight="true"
        appendTo="body"
        dataKey="value"
        delay="4"
        [minLength]="0"
        [style]="{'width':'100%'}"
        [ngClass]="{'p-autocomplete p-autocomplete-float-input order__dialog__accept-into__autocomplete--traderGroup': true,
							'p-autocomplete-float-input-valid': !!data.dialogData.autocomplete_traderGroup}"
      >
        <ng-template let-value pTemplate="item">
          <div class="ui-helper-clearfix">
            <div>{{value.label}}</div>
          </div>
        </ng-template>
      </bfx-autoComplete>

      <!--
		<div fxLayout="row" fxFlexFill>
		<p fxFlex>{{ data.dialogData.autocomplete_comment_text }}</p>
		<textarea
			fxFlex
			pInputTextarea
			onResize="helperAcceptInto_Resize($event)"
			[(ngModel)]="data.dialogData.autocomplete_comment_value"
			class="order__dialog__accept-into__textarea--comment"
		></textarea>
		</div>
		-->
    </div>
  </div>

  <p-footer fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="end center">
    <button
      pButton
      type="button"
      fxFlex="80px"
      class="bfx-button-secondary-subtle"
      (click)="actionAcceptInto_close()"
      label="Close"
    ></button>
    <ng-container *ngIf="data.dialogData.queryCallOrderRateSide; else confirm">
      <button
        pButton
        type="button"
        fxFlex="100px"
        class="bfx-button-primary"
        (click)="actionAcceptInto_confirm_topside()"
        label="Accept Top"
        [disabled]="!data.dialogData.autocomplete_traderGroup || !data.dialogData.autocomplete_traderGroup.value"
      ></button>
      <button
        pButton
        type="button"
        fxFlex="100px"
        class="bfx-button-primary"
        (click)="actionAcceptInto_confirm_downside()"
        label="Accept Down"
        [disabled]="!data.dialogData.autocomplete_traderGroup || !data.dialogData.autocomplete_traderGroup.value"
      ></button>
    </ng-container>
    <ng-template #confirm>
      <button
        pButton
        type="button"
        fxFlex="100px"
        class="bfx-button-primary"
        (click)="actionAcceptInto_confirm()"
        label="Accept Into"
        [disabled]="!data.dialogData.autocomplete_traderGroup || !data.dialogData.autocomplete_traderGroup.value"
      ></button>
    </ng-template>
  </p-footer>
</p-dialog>
